import { type LoaderFunction, redirect } from 'react-router'
import { AuthenticationError } from '#features/User/AuthenticationError'
import { getSessionState, userManager } from '#features/User/userManager'

export interface LoginRouteLoaderData {
  isRedirecting: boolean
  error?: AuthenticationError
}

export const loginRouteLoader: LoaderFunction = async ({ request }) => {
  const from = new URL(request.url).searchParams.get('from') ?? '/'
  const sessionState = getSessionState()

  if (!sessionState.user) {
    console.log('User not authenticated, redirecting to login')

    try {
      console.log('Attempting to sign in redirect with URL state:', from)
      await userManager.signinRedirect({
        url_state: from,
      })
    } catch (error) {
      console.error('Error during sign-in redirect:', error)
      return {
        isRedirecting: false,
        error: new AuthenticationError('Error during sign-in redirect', error),
      }
    }

    return {
      isRedirecting: true,
    }
  }

  if (sessionState.user?.expired) {
    try {
      console.log('User session expired, attempting silent sign-in')
      await userManager.signinSilent({
        url_state: from,
      })
      // If the silent sign-in is successful, we will redirect to the original URL below
    } catch (error) {
      console.error('Error signing in silently:', error)

      try {
        console.log('Attempting to sign in redirect with URL state:', from)
        await userManager.signinRedirect({
          url_state: from,
        })
      } catch (error) {
        console.error('Error during sign-in redirect:', error)
        return {
          isRedirecting: false,
          error: new AuthenticationError('Error during sign-in redirect', error),
        }
      }

      return {
        isRedirecting: true,
      }
    }
  }

  if (sessionState.user && !sessionState.user.expired) {
    console.log('User is authenticated, redirecting to original URL:', from)
    return redirect(from)
  }

  return {
    isRedirecting: false,
    error: new AuthenticationError('Unknown error: user is not authenticated and redirect failed'),
  }
}
